// InstitutionForm.form.js
import * as Yup from 'yup';

export function initialValues(user, institution, isNew) {
  return {
    institutionnam: isNew ? '' : institution?.institutionnam || '',
    address: isNew ? '' : institution?.address || '',
    city: isNew ? '' : institution?.city || '',
    country: isNew ? '' : institution?.country || '',
    phone: isNew ? '' : institution?.phone || '',
    website: isNew ? '' : institution?.website || '',
    avatar: isNew ? '' : institution?.avatar || '',
    fileAvatar: null,
    firstname: isNew ? '' : institution?.firstname || '',
    lastname: isNew ? '' : institution?.lastname || '',
    email: isNew ? '' : institution?.email || '',
    role: 'institution',
    partnerId: user.user._id, // asumes que user.user existe
    password: '',
    planEducaId: isNew ? '' : institution?.planEduca?._id || '',
    studentsnum: isNew ? '' : institution?.studentsnum || '',
    teachersnum: isNew ? '' : institution?.teachersnum || '',
  };
}

export function validationSchema(institution) {
  return Yup.object({
    institutionnam: Yup.string().required('La institución es obligatoria'),
    phone: Yup.string()
      .matches(/^[0-9]+$/, 'El teléfono solo puede contener números')
      .min(9, 'El teléfono debe tener al menos 9 dígitos')
      .required('El teléfono es obligatorio'),
    city: Yup.string().required('La ciudad es obligatoria'),
    planEducaId: Yup.string().required('El plan es obligatorio'),
    firstname: Yup.string().required('El nombre es obligatorio'),
    lastname: Yup.string().required('El apellido es obligatorio'),
    email: Yup.string().email('Debe ser un email válido').required('El email es obligatorio'),
    partnerId: Yup.string().required('El partnerId es obligatorio'),
    password: institution 
      ? Yup.string() 
      : Yup.string().required('La contraseña es obligatoria si es una nueva institución'),
  });
}
